module.exports = __webpack_public_path__ + "static/cer_dor_3-6cbd0d0f5e4cc8bf12f435640fef6a23.jpg";